import { useContext, useCallback, memo } from 'react';
import styled, { css } from 'styled-components';
import { palette } from '@cbhq/cds-web/tokens';
import { ActionType, ComponentType } from '@cbhq/client-analytics';
import globalNavLogEvent from '../../utils/globalNavLogEvent.js';
import '../../utils/useIsMobile/index.js';
import '../Link/index.js';
import './constants/index.js';
import GlobalNavContext from './context/GlobalNavContext.js';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import useIsMobile from '../../utils/useIsMobile/useIsMobile.js';
import { MOBILE_BREAKPOINT } from './constants/constants.js';
import Link from '../Link/Link.js';
const BANNER_PADDING_BOTTOM = 2;
const BANNER_HEIGHT = 35 + BANNER_PADDING_BOTTOM;
const DESKTOP_TEXT_LINE_HEIGHT = 19;
const MOBILE_TEXT_LINE_HEIGHT = 16;
const ARROW_ICON = ' →';
const componentsThemeMap = {
  default: {
    background: 'primary',
    foreground: 'background',
    foregroundAlternate: 'background'
  },
  light: {
    background: 'backgroundAlternate',
    foreground: 'foreground',
    foregroundAlternate: 'primary'
  },
  dark: {
    background: 'foreground',
    foreground: 'background',
    foregroundAlternate: 'primary'
  }
};
function Banner({
  message,
  url,
  onClick,
  superMessage,
  theme = 'default',
  textInBlue
}) {
  const _useContext = useContext(GlobalNavContext),
    detachBannerFromNav = _useContext.detachBannerFromNav;
  const isMobile = useIsMobile(MOBILE_BREAKPOINT);
  const onBannerClick = useCallback(() => {
    globalNavLogEvent('global_nav_banner_click', {
      action: ActionType.click,
      componentType: ComponentType.link,
      message
    });
    onClick?.();
  }, [onClick, message]);
  const _componentsThemeMap$t = componentsThemeMap[theme],
    background = _componentsThemeMap$t.background,
    foreground = _componentsThemeMap$t.foreground,
    foregroundAlternate = _componentsThemeMap$t.foregroundAlternate;
  return /*#__PURE__*/jsx(Wrapper, {
    onClick: onBannerClick,
    $backgroundColor: background,
    $detached: detachBannerFromNav,
    children: /*#__PURE__*/jsx(TextWrapperWithPadding, {
      children: url ? /*#__PURE__*/jsxs(Link, {
        to: url,
        children: [/*#__PURE__*/jsxs(Fragment, {
          children: [/*#__PURE__*/jsx(Text, {
            $isMobile: isMobile,
            $color: foreground,
            children: message
          }), ' ', textInBlue && /*#__PURE__*/jsx(Text, {
            $isMobile: isMobile,
            $color: foregroundAlternate,
            children: textInBlue
          })]
        }), /*#__PURE__*/jsx(Fragment, {
          children: superMessage && /*#__PURE__*/jsx(SuperText, {
            $isMobile: isMobile,
            $color: foreground,
            children: superMessage
          })
        }), /*#__PURE__*/jsx(Text, {
          $isMobile: isMobile,
          $color: textInBlue ? foregroundAlternate : foreground,
          children: ARROW_ICON
        })]
      }) : /*#__PURE__*/jsxs(Fragment, {
        children: [/*#__PURE__*/jsx(Text, {
          $isMobile: isMobile,
          $color: foreground,
          children: message
        }), ' ', textInBlue && /*#__PURE__*/jsx(Text, {
          $isMobile: isMobile,
          $color: foregroundAlternate,
          children: textInBlue
        })]
      })
    })
  });
}
const TextWrapperWithPadding = styled.div`
  padding: 10px;
`;
const Wrapper = styled.div`
  ${({
  $detached
}) => $detached ? css`
          position: fixed;
          top: 0;
          z-index: ${({
  theme
}) => theme.zIndex.top + 1};
        ` : 'position: relative;'}
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  min-height: ${BANNER_HEIGHT}px;
  background-color: ${({
  $backgroundColor
}) => palette[$backgroundColor]};
  padding-bottom: ${BANNER_PADDING_BOTTOM}px;

  ${({
  onClick
}) => !!onClick && css`
      cursor: pointer;
    `}
`;
const Text = styled.span`
  font-family: ${({
  theme
}) => theme.fontFamily.sans};
  color: ${({
  $color
}) => palette[$color]};
  font-size: ${({
  theme
}) => theme.fontSize.medium};
  line-height: ${DESKTOP_TEXT_LINE_HEIGHT}px;
  font-weight: ${({
  theme
}) => theme.fontWeight.demiBold};

  ${({
  $isMobile
}) => {
  return $isMobile ? css`
          font-size: ${({
    theme
  }) => theme.fontSize.small};
          line-height: ${MOBILE_TEXT_LINE_HEIGHT}px;
          font-weight: ${({
    theme
  }) => theme.fontWeight.sans};
        ` : '';
}}
`;
const SuperText = styled.sup`
  font-family: ${({
  theme
}) => theme.fontFamily.sans};
  color: ${({
  $color
}) => palette[$color]};
  font-size: ${({
  theme
}) => theme.fontSize.tiny};
  line-height: ${DESKTOP_TEXT_LINE_HEIGHT}px;
  font-weight: ${({
  theme
}) => theme.fontWeight.demiBold};

  ${({
  $isMobile
}) => {
  return $isMobile ? css`
          font-size: ${({
    theme
  }) => theme.fontSize.tiny};
          line-height: ${MOBILE_TEXT_LINE_HEIGHT}px;
          font-weight: ${({
    theme
  }) => theme.fontWeight.sans};
        ` : '';
}}
`;
const Banner$1 = /*#__PURE__*/memo(Banner);
export { BANNER_HEIGHT, componentsThemeMap, Banner$1 as default };
//# sourceMappingURL=Banner.js.map
